import { render, staticRenderFns } from "./SwitchBlock.vue?vue&type=template&id=5269cb82"
import script from "./SwitchBlock.vue?vue&type=script&lang=ts"
export * from "./SwitchBlock.vue?vue&type=script&lang=ts"
import style0 from "./SwitchBlock.vue?vue&type=style&index=0&id=5269cb82&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports